import { HotelFeePolicy } from "@/lib/redux/features/hotel/type"

/** Pick fee policies from API payload, keeping previous Redux values as fallback. */
export const resolveHotelFeePolicies = (
  incoming: unknown,
  ...fallbacks: Array<HotelFeePolicy[] | undefined>
): HotelFeePolicy[] => {
  if (Array.isArray(incoming) && incoming.length > 0) {
    return incoming as HotelFeePolicy[]
  }

  for (const fallback of fallbacks) {
    if (Array.isArray(fallback) && fallback.length > 0) {
      return fallback
    }
  }

  return []
}
